/* eslint-disable no-nested-ternary */
import React, { useMemo } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import {
  Login,
  ForgotPassword,
  ChangePassword,
  ValidateCard,
  Register,
  Home,
  ForgotEmail,
  EditUserData,
  AccessData,
  ProvisionalCard,
  Notifications,
  Indicacao,
  BuscaCNPJ,
  BuscaEndereco,
  SVA,
  AutoSelectIssuer,
} from '../pages';
import Footer from './Footer';
import { urls } from '~/config/constants';
import { getEnvFromUrl } from '~/helpers/getEnv';
import { getIssuer } from '~/helpers/getIssuer';

const GeneralContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;
function Routes() {
  const issuer = getIssuer();
  const routes = useMemo(() => {
    const items = [
      {
        path: `/${urls.login}`,
        component: Login,
        auth: false,
      },
      {
        path: `/${urls.forgotMyPassword}`,
        component: ForgotPassword,
        auth: false,
      },
      {
        path: `/${urls.createNewPassword}`,
        component: ChangePassword,
        auth: false,
      },
      {
        path: `/${urls.validateCard}`,
        component: ValidateCard,
        auth: true,
      },
      {
        path: `/${urls.register}`,
        component: Register,
        auth: false,
      },
      {
        path: `/${urls.home}`,
        component: Home,
        auth: true,
      },
      {
        path: `/${urls.forgotMyEmail}`,
        component: ForgotEmail,
      },
      {
        path: `/${urls.changePersonalData}`,
        component: EditUserData,
        auth: true,
      },
      {
        path: `/${urls.changeAccessData}`,
        component: AccessData,
        auth: true,
      },
      {
        path: `/${urls.provisionalCard}`,
        component: ProvisionalCard,
        auth: true,
      },
      {
        path: `/${urls.notifications}`,
        component: Notifications,
        auth: true,
      },
      {
        path: '/indique',
        component: BuscaCNPJ,
        auth: true,
      },
      {
        path: '/indique/endereco',
        component: BuscaEndereco,
        auth: true,
      },
      {
        path: '/indique/formulario',
        component: Indicacao,
        auth: true,
      },
      {
        path: '/indique/perguntas',
        component: Indicacao,
        auth: true,
      },
      {
        path: `/${urls.aditionalServices}`,
        component: SVA,
        auth: true,
      },
    ];

    const { isDynatrace } = getEnvFromUrl();
    if (isDynatrace) {
      items.push({
        path: '/vr',
        component: AutoSelectIssuer,
        auth: false,
      });

      items.push({
        path: '/caixa',
        component: AutoSelectIssuer,
        auth: false,
      });
    }

    return items;
  }, []);

  const user = useSelector(state => state.user);

  const isAuthenticated = (() => {
    if (issuer === 'VRPAT') {
      return !!user.email && !!user?.featuresFlag?.[0]?.status === true;
    }

    return !!user.email;
  })();

  const getPrivateRoutes = route => {
    return user.firstAccess
      ? route.path !== `/${urls.home}` && route.auth
      : route.path !== `/${urls.validateCard}` && route.auth;
  };

  const setPrivateRedirect = () =>
    user?.firstAccess ? `/${urls.validateCard}` : `/${urls.home}`;

  return (
    <GeneralContainer>
      <Switch>
        {routes
          .filter(
            route =>
              route.auth === null ||
              (isAuthenticated ? getPrivateRoutes(route) : !route.auth),
          )
          .map(route => (
            <Route exact key={route.path} {...route} />
          ))}
        {(!sessionStorage.getItem('token') ||
          (sessionStorage.getItem('token') && user?.email)) && (
          <Redirect
            to={isAuthenticated ? setPrivateRedirect() : `/${urls.login}`}
          />
        )}
      </Switch>
      <Footer />
    </GeneralContainer>
  );
}

export default Routes;
